import axios from 'axios';
import { GetUpLoadImgUrl } from '../api/weChat';
import { GetImageUploadUrl } from '../api/customer';
import { CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';

// 格式化日期，格式：年-月-日
export function formatDate(date) {
  const de = new Date(date);
  const y = de.getFullYear();
  const m = String(de.getMonth() + 1).padStart(2, '0');
  const d = String(de.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

// 格式化日期，格式：年月日
export function formatDateId(date) {
  const de = new Date(date);
  const y = de.getFullYear();
  const m = String(de.getMonth() + 1).padStart(2, '0');
  const d = String(de.getDate()).padStart(2, '0');
  return `${y}${m}${d}`;
}
// 格式化日期，格式：年.月.日
export function formatDateDot(date) {
  const de = new Date(date);
  const y = de.getFullYear();
  const m = String(de.getMonth() + 1).padStart(2, '0');
  const d = String(de.getDate()).padStart(2, '0');
  return `${y}.${m}.${d}`;
}

// 格式化日期，格式：年-月
export function formatDateYm(date) {
  const de = new Date(date);
  const y = de.getFullYear();
  const m = String(de.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
}

// 格式化日期，格式：年月日时分秒毫秒
export function formatDateLongStr(date) {
  const de = new Date(date);
  const yyyy = de.getFullYear();
  const MM = String(de.getMonth() + 1).padStart(2, '0');
  const dd = String(de.getDate()).padStart(2, '0');
  const HH = String(de.getHours()).padStart(2, '0');
  const mm = String(de.getMinutes()).padStart(2, '0');
  const ss = String(de.getSeconds()).padStart(2, '0');
  const SSS = String(de.getMilliseconds()).padStart(3, '0');
  return `${yyyy}${MM}${dd}${HH}${mm}${ss}${SSS}`;
}

/*
 * 判断obj是否为一个整数
 */
function isInteger(obj) {
  return Math.floor(obj) === obj;
}

/*
 * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
 * @param floatNum {number} 小数
 * @return {object}
 *   {times:100, num: 314}
 */
function toInteger(floatNum) {
  var ret = {
    times: 1,
    num: 0,
  };
  if (isInteger(floatNum)) {
    ret.num = floatNum;
    return ret;
  }
  var strfi = floatNum + '';
  var dotPos = strfi.indexOf('.');
  var len = strfi.substr(dotPos + 1).length;
  var times = Math.pow(10, len);
  var intNum = parseInt(floatNum * times + 0.5, 10);
  ret.times = times;
  ret.num = intNum;
  return ret;
}

/*
 * 核心方法，实现加减乘除运算，确保不丢失精度
 * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
 *
 * @param a {number} 运算数1
 * @param b {number} 运算数2
 * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
 *
 */
function operation(a, b, op) {
  var o1 = toInteger(a);
  var o2 = toInteger(b);
  var n1 = o1.num;
  var n2 = o2.num;
  var t1 = o1.times;
  var t2 = o2.times;
  var max = t1 > t2 ? t1 : t2;
  var result = null;
  switch (op) {
    case 'add':
      if (t1 === t2) {
        // 两个小数位数相同
        result = n1 + n2;
      } else if (t1 > t2) {
        // o1 小数位 大于 o2
        result = n1 + n2 * (t1 / t2);
      } else {
        // o1 小数位 小于 o2
        result = n1 * (t2 / t1) + n2;
      }
      return result / max;
    case 'subtract':
      if (t1 === t2) {
        result = n1 - n2;
      } else if (t1 > t2) {
        result = n1 - n2 * (t1 / t2);
      } else {
        result = n1 * (t2 / t1) - n2;
      }
      return result / max;
    case 'multiply':
      result = (n1 * n2) / (t1 * t2);
      return result;
    case 'divide':
      result = (n1 / n2) * (t2 / t1);
      return result;
  }
}

// 加减乘除的四个接口
export function add(a, b) {
  return operation(a, b, 'add');
}

export function subtract(a, b) {
  return operation(a, b, 'subtract');
}

export function multiply(a, b) {
  return operation(a, b, 'multiply');
}

export function divide(a, b) {
  return operation(a, b, 'divide');
}

// 上传图片
export function upLoadImg(
  blob,
  base64,
  type,
  mobile,
  yes = null,
  no = null,
  startIndex = 0
) {
  CusLoadingOpen('上传中...');
  GetUpLoadImgUrl()
    .then((res) => {
      if (res.code === 0) {
        const formData = new FormData();
        formData.append('fileField', blob || b64toBlob(base64), 'picture.jpg');
        // 身份证正面
        if (type === 'renXiang' || type === 'grantRenXiang') {
          formData.append('fileType', 'idcardFront');
        }
        // 身份证背面
        if (type === 'guoHui' || type === 'grantGuoHui') {
          formData.append('fileType', 'idcardBack');
        }
        // 人脸识别
        if (type === 'renLian' || type === 'ymt') {
          formData.append('fileType', 'xspic');
        }
        // 手持身份证
        if (type === 'shouChi') {
          formData.append('fileType', 'handIdCardPic');
        }
        // 手持身份证（银行卡解锁）
        if (type === 'unlockIdCard') {
          formData.append('fileType', 'unlockidcard');
        }
        // 手持银行卡（银行卡解锁）
        if (type === 'unlockBankCard') {
          formData.append('fileType', 'unlockbankcard');
        }
        // 风控管理
        if (type === 'uploadHeader' || type === 'uploadCashier' || type === 'uploadIndoor' || type === 'uploadCertificate') {
          formData.append('fileType', 'riskManagementPic');
        }
        formData.append('mobile', mobile);
        axios
          .post(res.rows[startIndex], formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            CusLoadingClose();
            yes && yes(res.data);
          })
          .catch((err) => {
            CusLoadingClose();
            const i = startIndex + 1;
            if (i < res.rows.length) upLoadImg(blob, base64, type, mobile, yes, no, i);
            else no && no(err);
          });
      } else {
        CusLoadingClose();
        no && no(res);
      }
    })
    .catch(err => {
      CusLoadingClose();
      no && no(err);
    });
}

// 代理商的助手App上传图片功能
export function upLoadImgForAgent(blob, base64, type, yes = null, no = null) {
  CusLoadingOpen('上传中...');
  GetImageUploadUrl().then((res) => {
    const formData = new FormData();
    formData.append('fileField', blob || b64toBlob(base64), 'picture.jpg');
    switch (type) {
      case 'renXiang': // 身份证正面
      case 'grantRenXiang': // 身份证正面
        formData.append('fileType', 'idcardFront');
        break;
      case 'guoHui': // 身份证背面
      case 'grantGuoHui': // 身份证背面
        formData.append('fileType', 'idcardBack');
        break;
      case 'renLian': // 人脸识别
      case 'ymt': // 人脸识别
      case 'faceverifyPicture': // 人脸识别
      case 'onlyFacePicture': // 人脸识别
        formData.append('fileType', 'xspic');
        break;
      case 'shouChi': // 手持身份证
      case 'idCardPicture': // 手持身份证
        formData.append('fileType', 'handIdCardPic');
        break;
      case 'unlockIdCard': // 手持身份证（银行卡解锁）
        formData.append('fileType', 'unlockidcard');
        break;
      case 'unlockBankCard': //  手持银行卡（银行卡解锁）
        formData.append('fileType', 'unlockbankcard');
        break;
      case 'uploadHeader': // 风控管理
      case 'uploadCashier': // 风控管理
      case 'uploadIndoor': // 风控管理
      case 'uploadCertificate': // 风控管理
        formData.append('fileType', 'riskManagementPic');
        break;
      case 'licensePicture': //  营业执照
      case 'businessLicense': //  营业执照
      case 'accountLicense': //  营业执照
        formData.append('fileType', 'merchantStoreLicensePic');
        break;
      case 'shopPicture': //  店铺门头照
        formData.append('fileType', 'merchantShopEnvironmentPic');
        break;
      case 'placePicture': //  经营场所照
        formData.append('fileType', 'merchantShopPlacePic');
        break;
      case 'cashierPicture': //  收银台照
        formData.append('fileType', 'merchantStoreCashierPic');
        break;
      case 'grantBankCardPicture': //  银行卡
        formData.append('fileType', 'bank');
        break;
      case 'commitmentPicture': //  真商图片
      case 'agreementFile1': //  真商图片
      case 'agreementFile2': //  真商图片
      case 'agreementFile3': //  真商图片
      case 'agreementFile4': //  真商图片
      case 'agreementFile5': //  真商图片
      case 'agreementFile6': //  真商图片
      case 'other1Picture': //  真商图片
      case 'other2Picture': //  真商图片
        formData.append('fileType', 'realCustomerPic');
        break;
    }
    axios
      .post(res.data.url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        CusLoadingClose();
        yes && yes(res.data);
      })
      .catch((err) => {
        CusLoadingClose();
        no && no(err);
      });
  });
}

// 无登录上传图片功能
export function commitmentUpLoadImg(
  blob,
  base64,
  type,
  url,
  yes = null,
  no = null
) {
  CusLoadingOpen('上传中...');
  const formData = new FormData();
  formData.append('fileField', blob || b64toBlob(base64), 'picture.jpg');
  if (type === 'agreePicture') {
    formData.append('fileType', 'realCustomerPic');
  }
  axios
    .post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => {
      CusLoadingClose();
      yes && yes(res.data);
    })
    .catch((err) => {
      CusLoadingClose();
      no && no(err);
    });
}

// base64转Blob
function b64toBlob(b64) {
  const str64 = b64.indexOf(',') > -1 ? b64.split(',')[1] : b64;
  const byteString = window.atob(str64);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], {
    type: 'image/jpeg',
  });
}
